import { useEffect } from "react";
import { envService } from "../config/env";

const DynamicFavicon = () => {
  useEffect(() => {
    const setFavicon = () => {
      let faviconLink = document.querySelector<HTMLLinkElement>('link[rel="icon"]');

      // Create favicon link element if it doesn't exist
      if (!faviconLink) {
        faviconLink = document.createElement("link");
        faviconLink.rel = "icon";
        document.head.appendChild(faviconLink);
      }

      if (envService.isProduction()) {
        faviconLink.href = "/favicon.png";
      } else if (envService.isStaging()) {
        faviconLink.href = "/favicon_staging.png";
      } else if (envService.isDevelopment() || envService.isLocal()) {
        faviconLink.href = "/favicon_dev.png";
      }
    };

    setFavicon();
  }, []);

  return null;
};

export default DynamicFavicon;
